import { type TypedUseSelectorHook, useSelector } from "react-redux";
import type { AppState } from "../root-reducer";

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
